<template>
  <!-- 네이티브화로 네비게이션은 웹일때만 노출합니다 : 대경님 요청사항 -->
  <!-- 단, 2.2.6 이하 앱은 자체 하단 네비가 없어 웹 GNB 가 유일한 이동 수단이므로 노출한다. -->
  <NavigationIndex
    v-if="!isNativeShell"
    :route-url="routeUrl"
  />
</template>

<script setup lang="ts">
import type { GnbRouteUrl } from '~/types/layouts/navigation'
import { isNativeShellAppUA } from '@/utils/appBridgeGate'

const { isApp, userAgent } = useAppCheck()

// 앱이면서 2.2.7 이상일 때만 숨긴다.
const isNativeShell = computed(() => isApp && isNativeShellAppUA(userAgent))

const routeUrl = ref<GnbRouteUrl>({
  home: '/',
  inventory: '/inventory',
  benefit: '/benefit',
  user: '/user',
  setting: '/settings'
})
</script>
